"use client";
import AuthDrawer from "@/components/common/drawer/AuthDrawer/AuthDrawer";
import LoginForm from "@/components/common/drawer/AuthDrawer/components/LoginForm";
import CommonImage from "@/components/common/image/CommonImage";
import { closeDrawer } from "@/redux/slices/authDrawerSlice";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import { MdKeyboardArrowRight } from "react-icons/md";

const Modal = dynamic(() => import('antd/es/modal'), { ssr: false });

export default function Login() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const setting = useSelector((state) => state.setting.data);
  const showModal = () => setIsModalOpen(true);

  const router = useRouter();
  const pathName = usePathname();

  console.log("pathName", pathName);
  return (
    <>
      {" "}
      <section className="login_section">

        <div className="login-section-card">
          <div className="container">
            <div className="login-breadcrumb">
              <ul>
                <li>হোম</li>
                <li><MdKeyboardArrowRight className="arrow-icon" /></li>
                <li><Link href={'#'}>লগইন</Link></li>
              </ul>
            </div>
            <div className="login-title-card">
              <h1 className="title">
                <span className="highlighted">লগইন করুন,</span> Focus এর অভিজ্ঞতায় যুক্ত হন</h1>
            </div>
          </div>
          <Image
            src={'/images/admission-icon/login-now.png'}
            alt={'login'}
            width={105}
            height={105}
            className="login_now_icon"
          />
        </div>
        <div className="container">
          <div className="login-page-card">
            <div className="login-registation-card">
              <div className="grid grid-cols-12 gap-6">
                <div className="lg:col-span-5 col-span-12">
                  <div className="video-part">
                    <div className="top-title">
                      <Image
                        src={"/images/admission-icon/login-icon.png"}
                        className="top-icon"
                        alt="Icon"
                        width={11}
                        height={16}
                      />
                      <span className="">
                        লগইন
                      </span>
                    </div>
                    <h2 className="second-title">কিভাবে লগইন করবেন ?</h2>
                    <div className="login-video-thumbnail">
                      <CommonImage
                        src={
                          setting?.login_video_thumble_url ??
                          "/images/login/login-video-thumbnail.avif"
                        }
                        alt={"Image"}
                        className="login-thumbnail"
                      />
                      <div className="login-playbtn">
                        <button className="play-btn" onClick={showModal}>
                          <FaCirclePlay className="play-icon" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-7 col-span-12">
                  <div className="">
                    <div className="">

                      <div className="login-form">
                        <LoginForm
                          toast={toast}
                          setDrawerOpen={() => dispatch(closeDrawer())}
                          pageType="login"
                          pathName={pathName}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          centered
          width={800}
          className="video-modal"
          styles={{
            body: {
              padding: 0,
            },
          }}
          destroyOnHidden
        >
          <div className="aspect-video w-full">
            <YoutubePlayer
              url={isModalOpen ? setting?.login_video_link : null}
            />
          </div>
        </Modal>

        <AuthDrawer />
      </section>
    </>
  );
}
